import React, { useState } from "react";
import styles from "../styles/Header.module.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "./LanguageDropdown";

export default function Header() {
  const { t } = useTranslation(["Header"]);
  const navigate = useNavigate();

  const userRole = localStorage.getItem("userRole");

  const [showDropdown, setShowDropdown] = useState(false);

  const handleMouseEnter = () => {
    setShowDropdown(true);
  };

  const handleMouseLeave = () => {
    setShowDropdown(false);
  };

  const onLogoClick = (event) => {
    event.preventDefault();
    navigate("/");
  };

  return (
    <div className={styles.navBar}>
      <div className={styles.navContent}>
        <div className={styles.logo} onClick={onLogoClick}>
          <a
            href={`${process.env.REACT_APP_FRONTEND_URL}/`}
            rel="noopener noreferrer"
          >
            <img
              src="/bidd_logo.svg"
              alt="bidd-logo"
              className={styles.logoImage}
              width="160"
              height="40"
            />
          </a>
        </div>
        <div className={styles.linksContainer}>
          <div className={styles.otherLinks}>
            <LanguageDropdown />
            <div
              className={styles.loginBtn}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className={styles.link}>
                {userRole === "Employee"
                  ? t("contractor")
                  : userRole === "Manager"
                  ? t("institution")
                  : t("myPages")}
              </div>
              {showDropdown && (
                <div className={styles.dropdown}>
                  <div
                    className={styles.option}
                    onClick={() => {
                      localStorage.setItem("userRole", "Employee");
                      navigate("/login");
                      // navigate("/authorize");
                    }}
                  >
                    {t("contractor")}
                  </div>
                  <div
                    className={styles.option}
                    onClick={() => {
                      localStorage.setItem("userRole", "Manager");
                      navigate("/login");
                      // navigate("/authorize");
                    }}
                  >
                    {t("institution")}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
